import img1 from './assets/1.jpeg';
import imgAdobe from './assets/AdobeStock_1155900392.jpeg';
import img2 from './assets/2.jpeg';
import imgProdukt from './assets/produkt.jpeg';

const categoryImages = {
  web: img1,
  graphic: imgAdobe,
  uiux: img2,
  photo: imgProdukt,
};

function getAllServicesByCategory(language) {
  const isDe = language === 'de';

  return {
    web: [
      {
        title: isDe ? 'Konzept & Vision' : 'Concept & Vision',
        description: isDe
          ? 'Wir tauchen tief in den Kern deiner Vision ein. In enger Zusammenarbeit entwickeln wir maßgeschneiderte Konzepte, die deine Ziele und die DNA deines Unternehmens widerspiegeln. Von ersten Skizzen bis zum fertigen Plan – wir machen deine Ideen greifbar.'
          : "We dive deep into the core of your vision. Working closely together, we develop tailored concepts that reflect your goals and your company's DNA. From initial sketches to the final plan – we make your ideas tangible.",
      },
      {
        title: isDe ? 'Webdesign & Entwicklung' : 'Webdesign & Development',
        description: isDe
          ? 'Kreativ trifft Code: Unsere Designer:innen und Entwickler:innen kreieren Websites, die nicht nur optisch überzeugen, sondern auch funktional glänzen. Mit modernsten Technologien und intuitivem UX/UI-Design bauen wir digitale Erlebnisse, die begeistern und Ergebnisse liefern.'
          : 'Creative meets Code: Our designers and developers create websites that not only look impressive but also shine functionally. Using cutting-edge technologies and intuitive UX/UI design, we build digital experiences that inspire and deliver results.',
      },
      {
        title: isDe ? 'Sicherheit & Datenschutz' : 'Security & Privacy',
        description: isDe
          ? 'Dein digitaler Schutzschild: Wir implementieren robuste Sicherheitsprotokolle und halten uns stets an aktuelle Datenschutzstandards. Egal ob SSL, DSGVO oder regelmäßige Audits – deine Daten bleiben safe.'
          : 'Your digital shield: We implement robust security protocols and always adhere to current data protection standards. Whether SSL, GDPR, or regular audits – your data stays safe.',
      },
      {
        title: isDe ? 'Hosting & E-Mail-Services' : 'Hosting & Email Services',
        description: isDe
          ? 'Souverän online: Mit unserer hochverfügbaren Hosting-Lösung und professionellen Business-E-Mails legst du ein solides digitales Fundament. Kein Server-Stress – wir kümmern uns um die Technik, du um dein Business.'
          : 'Sovereign online: With our highly available hosting solution and professional business emails, you lay a solid digital foundation. No server stress – we take care of the technology, you focus on your business.',
      },
      {
        title: isDe ? 'Wartung & Support' : 'Maintenance & Support',
        description: isDe
          ? 'Allzeit bereit: Unser Service endet nicht mit dem Launch. Mit 24/7-Monitoring, Updates on Demand und schnellem Support sorgen wir dafür, dass deine Website immer topfit bleibt.'
          : "Always ready: Our service doesn't end with the launch. With 24/7 monitoring, updates on demand, and quick support, we ensure your website stays in top shape.",
      },
    ],
    graphic: [
      {
        title: isDe ? 'Logo Design' : 'Logo Design',
        description: isDe
          ? 'Professionelle Logoentwicklung, die deine Markenidentität perfekt zum Ausdruck bringt. Von der Konzeption bis zur finalen Ausarbeitung in allen gängigen Dateiformaten.'
          : 'Professional logo development that perfectly expresses your brand identity. From conception to final execution in all common file formats.',
      },
      {
        title: isDe ? 'Print Design' : 'Print Design',
        description: isDe
          ? 'Gestaltung von Geschäftsausstattung, Broschüren, Flyern und allen weiteren Printmedien. Druckfertige Aufbereitung inklusive.'
          : 'Design of business equipment, brochures, flyers, and all other print media. Print-ready preparation included.',
      },
      {
        title: isDe ? 'Bildbearbeitung' : 'Image Editing',
        description: isDe
          ? 'Professionelle Fotoretusche, Freisteller und Bildoptimierung für Web und Print. Perfekte Bilder für jeden Einsatzzweck.'
          : 'Professional photo retouching, cutouts, and image optimization for web and print. Perfect images for every purpose.',
      },
    ],
    uiux: [
      {
        title: 'UX Research',
        description: isDe
          ? 'Nutzerforschung und Analyse für optimale Benutzererfahrung. Personas, User Journeys und Usability Tests für fundierte Design-Entscheidungen.'
          : 'User research and analysis for optimal user experience. Personas, user journeys, and usability tests for well-founded design decisions.',
      },
      {
        title: 'UI Design',
        description: isDe
          ? 'Gestaltung moderner, intuitiver Benutzeroberflächen. Von Wireframes bis zum finalen Design, immer mit Fokus auf Benutzerfreundlichkeit.'
          : 'Design of modern, intuitive user interfaces. From wireframes to final design, always focusing on user-friendliness.',
      },
      {
        title: 'Prototyping',
        description: isDe
          ? 'Interaktive Prototypen zur Visualisierung und Testung. Schnelle Iteration und Optimierung vor der Entwicklung.'
          : 'Interactive prototypes for visualization and testing. Rapid iteration and optimization before development.',
      },
    ],
    photo: [
      {
        title: isDe ? 'Produktfotografie' : 'Product Photography',
        description: isDe
          ? 'Professionelle Produktaufnahmen für E-Commerce und Marketing. Perfekte Ausleuchtung und Inszenierung Ihrer Produkte für maximale Wirkung.'
          : 'Professional product shots for e-commerce and marketing. Perfect lighting and staging of your products for maximum impact.',
      },
      {
        title: isDe ? 'Architekturfotografie' : 'Architecture Photography',
        description: isDe
          ? 'Eindrucksvolle Aufnahmen von Gebäuden und Räumen. Perfekte Perspektiven und optimale Lichtverhältnisse für beeindruckende Architekturdarstellung.'
          : 'Impressive shots of buildings and spaces. Perfect perspectives and optimal lighting conditions for impressive architectural presentation.',
      },
      {
        title: isDe ? 'Post-Production' : 'Post-Production',
        description: isDe
          ? 'Professionelle Bildbearbeitung und Retusche. Farbkorrektur, Compositing und Detail-Optimierung für perfekte Endergebnisse.'
          : 'Professional image editing and retouching. Color correction, compositing, and detail optimization for perfect end results.',
      },
    ],
  };
}

export function getServiceCategories(language) {
  const isDe = language === 'de';

  return [
    {
      id: 'web',
      title: isDe ? 'Web & App Development' : 'Web & App Development',
      iconKey: 'web',
    },
    {
      id: 'graphic',
      title: isDe ? 'Grafikdesign' : 'Graphic Design',
      iconKey: 'graphic',
    },
    {
      id: 'uiux',
      title: isDe ? 'UI/UX Design' : 'UI/UX Design',
      iconKey: 'uiux',
    },
    {
      id: 'photo',
      title: isDe ? 'Fotografie' : 'Photography',
      iconKey: 'photo',
    },
  ];
}

export function getAllServiceOffers(language) {
  return getServiceCategories(language).flatMap((category) =>
    getServicesForCategory(category.id, language)
  );
}

export function getServiceTiles(language) {
  return getServiceCategories(language).flatMap((category) =>
    getServicesForCategory(category.id, language).map((service, index) => ({
      id: `${category.id}-${index}`,
      image: categoryImages[category.id],
      title: service.title,
      description: service.description,
    }))
  );
}

export function getCategoryImage(categoryId) {
  return categoryImages[categoryId] ?? categoryImages.web;
}

export function getServicesForCategory(categoryId, language) {
  const byCategory = getAllServicesByCategory(language);

  return byCategory[categoryId] ?? byCategory.web;
}
